import { UserType } from '@constants//app';
import { UserType as GqlUserType } from '@graphql/user/generated/graphql.types';

export function asUserType(input: GqlUserType): UserType;
export function asUserType(input: UserType): GqlUserType;
export function asUserType(input: UserType | GqlUserType): UserType | GqlUserType {
  if (input === UserType.ADMIN) return GqlUserType.Admin;
  if (input === UserType.USER) return GqlUserType.User;
  if (input === GqlUserType.Admin) return UserType.ADMIN;
  return UserType.USER;
}